'use strict';

import { io, sub, base, Component, PropTypes, cloneElement } from 'core';

import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';

import { zoomTransition } from 'transitions/slider';

import Header from 'c/header';
import Toolbar from 'c/header/toolbar';

import Footer from 'c/footer';

window.onresize = function() {
    onresize(window.document
                   .getElementsByTagName('react')[0]
                   .getBoundingClientRect());
}

const onresize = _.debounce(function({ height, width }) {
    io.emit('document:resize', { width, height });
}, 100);

@base({
    track: [['router', 'location']]
})
class Internal extends Component {

    styles = {
        page: {
            position: 'fixed', bottom: 0, left: 0,
            width: '100%', height: '100%', minHeight: '100%'
        },
        content: {
            height: '100%', minHeight: '100%',
            margin: '140px 0 0 0', padding: '0',
            position: 'relative'
        },
        contentInner: {
            height: 'calc(92% - 150px)',
            width: '100%', position: 'relative'
        }
    }

	render() {

        const { get, children } = this.props;

        const key = `in:content:${window.location.pathname.replace(/\//g, ':')}`;

        return (
  			<div className="internal" style={ this.styles.page }>

                {/* App internal view - header + toolbar */}
                <Header toolbar />

                <div className="internal-content" style={ this.styles.content }>

                    {/* Page router handler*/}
                    <VelocityTransitionGroup {...zoomTransition()}>
                        <div className="internal-content-page_wrapper"
                             key={ key } style={ this.styles.contentInner }>
                            { cloneElement(children, this._atom()) }
                        </div>
                    </VelocityTransitionGroup>

                    <Footer />
                </div>
            </div>
  		);
	}
};

export default Internal



// WEBPACK FOOTER //
// ./ui/c/layout/internal.jsx